import React, { ReactNode } from 'react';

import InlineTextInput from './InlineTextInput';
import { RenderInputProps, ValueType } from './types';

export const defaultValueRenderer = (value: ValueType): ReactNode => {
  return typeof value === 'object' ? value?.toString() : value;
};

/**
 * Default input renderer for InlineEdit. Drops `onChange` and `editMode`
 * from the forwarded props — `onChange` is owned by InlineEdit's change flow;
 * `editMode` is only meaningful to custom renderers that need to react to edit
 * mode transitions (e.g. re-opening a dropdown menu).
 */
export const defaultRenderInput = <TValue extends ValueType>({
  value: inputValue,
  onChange: _onChange,
  editMode: _editMode,
  ...renderInputProps
}: RenderInputProps<TValue>) => {
  return <InlineTextInput value={inputValue as string} {...renderInputProps} />;
};
